import { cn } from '../cn/cn';
import { AppSpinner } from '../AppSpinner/AppSpinner';

/**
 * A region's loading state: a padded, centred spinner. `QueryNotReady` draws
 * it, and other sites use it directly (a form awaiting defaults, a `Suspense`
 * fallback).
 *
 * A tiny component earns a file because it names a state, not a layout: its
 * classes are identical at every site. It is named for the state, not the
 * spinner's shape, so it doesn't invite spinner variants.
 */
export const LoadingBlock = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex w-full flex-col items-center p-4', className)}>
      <AppSpinner />
    </div>
  );
};
